"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateMaximumPrefundingAmount = exports.createMaximumPrefundingAmountAvailableFieldProposals = exports.createMaximumPrefundingAmountEvaluator = exports.checkMaximumPrefundingAmountConfigErrors = void 0;
const lodash_1 = __importDefault(require("lodash"));
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const AVAILABLE_FORMULA_FIELDS = {
    commitmentAmount: 'total commitment amount of all capital providers',
};
/**
 * Maximum prefunding amount formulas can use variables from {@link CreditAgreement.Config.MaximumPrefundingAmount.AvailableFormulaFields}
 */
const checkMaximumPrefundingAmountConfigErrors = ({ maximumPrefundingAmountConfig, }) => {
    const availableFormulaFields = Object.keys(AVAILABLE_FORMULA_FIELDS);
    const availableVariables = new Set(availableFormulaFields);
    (0, common_1.finleyAssert)(maximumPrefundingAmountConfig.type === 'formula', `unexpected maximumPrefundingAmountConfig.type: [${maximumPrefundingAmountConfig.type}]`);
    const { errorMessages } = (0, formula_engine_1.getFormulaErrors)(maximumPrefundingAmountConfig.config.formula, availableVariables);
    return errorMessages;
};
exports.checkMaximumPrefundingAmountConfigErrors = checkMaximumPrefundingAmountConfigErrors;
const createMaximumPrefundingAmountEvaluator = (maximumPrefundingAmountConfig) => {
    // extract formula from the config.
    // instantiate FormulaEngine with all formula strings
    // we need to do this upfront to ensure that formula's AST are cached.
    (0, common_1.finleyAssert)(maximumPrefundingAmountConfig.type === 'formula', `Expected maximum prefunding amount config type [${maximumPrefundingAmountConfig.type}] to be formula`);
    (0, common_1.finleyAssert)(maximumPrefundingAmountConfig.config.engineVersion ===
        finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, `${maximumPrefundingAmountConfig.config.engineVersion} is not supported for HyperForumla engine`);
    const formulaString = maximumPrefundingAmountConfig.config.formula;
    const formulaEngine = (0, formula_engine_1.createFormulaEngine)(finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, [formulaString]);
    const evaluateConfig = (availableFields) => {
        const formulaInputs = common_1.utils.generateFlattenNestedKeyObject(availableFields);
        formulaEngine.setVariables(formulaInputs);
        return formulaEngine.evaluateNumber(formulaString);
    };
    return {
        evaluateConfig,
    };
};
exports.createMaximumPrefundingAmountEvaluator = createMaximumPrefundingAmountEvaluator;
const createMaximumPrefundingAmountAvailableFieldProposals = () => {
    return lodash_1.default.map(lodash_1.default.toPairs(AVAILABLE_FORMULA_FIELDS), ([label, documentation]) => ({
        label,
        documentation,
        insertText: label,
    }));
};
exports.createMaximumPrefundingAmountAvailableFieldProposals = createMaximumPrefundingAmountAvailableFieldProposals;
/**
 * expected that this will be refactored to be an async method when pointer methods are implemented
 */
const calculateMaximumPrefundingAmount = ({ maximumPrefundingAmountConfig, availableFields, }) => {
    if (!maximumPrefundingAmountConfig) {
        return 0; // default value
    }
    switch (maximumPrefundingAmountConfig.type) {
        case 'formula':
            return (0, exports.createMaximumPrefundingAmountEvaluator)(maximumPrefundingAmountConfig).evaluateConfig(availableFields);
        // case 'pointer':
        // TO BE IMPLEMENTED
        default:
            return (0, common_1.finleyAssertUnreachable)(maximumPrefundingAmountConfig.type);
    }
};
exports.calculateMaximumPrefundingAmount = calculateMaximumPrefundingAmount;
//# sourceMappingURL=maximumPrefundingAmountEvaluator.js.map